import { resolveAppLocale } from './resolveLocale'
import { readLocalePreference } from './storage'
import type { AppLocale } from './types'

let runtimeLocale: AppLocale = resolveAppLocale(readLocalePreference())

export function getRuntimeLocale(): AppLocale {
  return runtimeLocale
}

export function setRuntimeLocale(locale: AppLocale): void {
  runtimeLocale = locale
}
